export enum PaymentMethodsType {
  Card = 'Card',
  BankAccount = 'BankAccount',
  PaymentTokenAccount = 'PaymentTokenAccount',
}
export interface ICard {
  id: string;
  brand: string;
  exp_year: number;
  exp_month: number;
  last4: string;
  paymentType: PaymentMethodsType.Card;
  source: PaymentMethodSource.STRIPE | PaymentMethodSource.CHECKOUT;
}

export interface IBankAccount {
  id: string;
  last4: string;
  bank_code?: string;
  paymentType: PaymentMethodsType.BankAccount;
  source: PaymentMethodSource.STRIPE;
}

export interface IPaymentTokenAccount {
  id: string;
  email: string;
  source: PaymentMethodSource.PAYPAL;
  paymentType: PaymentMethodsType.PaymentTokenAccount;
}

export type PaymentMethod = IBankAccount | ICard | IPaymentTokenAccount;

export interface ICreateSubscriptionIntentResult {
  createSubscriptionIntent: string;
}

export interface ISubscriptionPaymentMethodQueryResult {
  getCurrentPaymentMethod: PaymentMethod;
}

export interface IPaymentMethodsQueryResult {
  getCurrentPaymentMethods: PaymentMethod[];
}

export interface ICreatePaymentTokenResult {
  createPaymentToken: {
    authorizationToken: string;
  };
}
export interface IAuthorizePaymentTokenResult {
  authorizePaymentToken: {
    token: string;
  };
}

export interface IStartApplePaySessionResult {
  startApplePaySession: {
    session: unknown;
  };
}

export enum FirebasePaymentMethodsType {
  Card = 'card',
  BankAccount = 'bank_account',
}

export interface IFirebaseCard {
  id: string;
  brand: string;
  exp_year: number;
  exp_month: number;
  last4: number;
  type: FirebasePaymentMethodsType.Card;
}

export interface IFirebaseBankAccount {
  id: string;
  brand: string;
  type: FirebasePaymentMethodsType.BankAccount;
}

export type FirebasePaymentMethod = IFirebaseCard | IFirebaseBankAccount;

export enum PSPEnum {
  PAYPAL = 'paypal',
  CHECKOUT = 'checkout',
  STRIPE = 'stripe',
}

export enum PaymentMethodsEnum {
  CARD = 'card',
  SEPA = 'sepa_debit',
  PAYPAL = 'payment_token', // paypal
  APPLE_PAY = 'apple_pay',
}

export enum ExtendedPaymentMethodsEnum {
  PAYPAL4X = 'paypal4x',
}

export const PaymentMethodTypes = {
  ...PaymentMethodsEnum,
  ...ExtendedPaymentMethodsEnum,
};

export type PaymentMethodTypesEnum =
  (typeof PaymentMethodTypes)[keyof typeof PaymentMethodTypes];

export enum PaymentTokenType {
  PAYPAL_BILLING_AGREEMENT = 'paypal_billing_agreement',
}

export enum PaymentTokenState {
  UNAUTHORIZE = 'unauthorize',
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
}

export enum PaymentMethodSource {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  CHECKOUT = 'checkout',
  APPLE_PAY = 'apple_pay',
}

export interface IAsyncPayment {
  redirectLink: string;
  id: string;
}

export interface IPayment {
  paymentMethodId: string;
}

export interface ICreatePaymentWith3DSResult {
  createPaymentWith3DS: IAsyncPayment;
}

export interface IGetPaymentResult {
  getPayment: IPayment;
}

interface ICheckoutComPaymentDetailsActions {
  id: string;
  type: string;
  response_code: string;
  response_summary?: string;
}

interface ICheckoutComPaymentDetails {
  id: string;
  payment_type?: string;
  status?: string;
  approved: boolean;
  actions?: ICheckoutComPaymentDetailsActions[];
  threeDS?: {
    downgraded?: boolean;
    enrolled?: string;
    authentication_response?: string;
    version?: string;
    exemption?: string;
    challenged?: boolean;
    exemption_applied?: string;
  };
}

export interface IGetCheckoutComPaymentDetailsResult {
  getCheckoutComPaymentDetails: ICheckoutComPaymentDetails;
}

export interface ICardForm {
  isComplete: boolean;
  cardTemporaryToken: string | null;
  saveCardForFutureUse: boolean;
}

export const PaymentMetadataApps = {
  WEB: 'web',
  MOBILE: 'mobile',
} as const;

export type PaymentMetadataApp =
  (typeof PaymentMetadataApps)[keyof typeof PaymentMetadataApps];

export const PaymentMetadataPlatforms = {
  WEB: 'web',
  UNKNOWN: 'unknown',
  IOS: 'ios',
  ANDROID: 'android',
} as const;

export type PaymentMetadataPlatform =
  (typeof PaymentMetadataPlatforms)[keyof typeof PaymentMetadataPlatforms];

export type PaymentMetadata = {
  app: PaymentMetadataApp;
  platform: string;
};
